import { createRootRoute, Outlet } from '@tanstack/react-router'

import { useGovBrSession } from '@/hooks/use-govbr-session'

import { AppFooter } from '@/components/layout/AppFooter'
import { AppHeader } from '@/components/layout/AppHeader'
import { Toaster } from '@/components/ui/sonner'

/*
 * Composição de tela do DS, padrão Formulário/Fluxo: Header, Breadcrumb, Box,
 * Toast flutuante e Footer (DESIGN.md, "Composição de tela"). Breadcrumb, Page
 * Title e Box são responsabilidade de cada tela — ver `layout/PageShell`.
 */
export function Layout() {
  useGovBrSession()

  return (
    <div className="flex min-h-dvh flex-col bg-surface">
      <AppHeader />

      <main className="flex-1">
        <Outlet />
      </main>

      <AppFooter />
      <Toaster />
    </div>
  )
}

export const Route = createRootRoute({ component: Layout })
